// extracted by mini-css-extract-plugin
export default {"area-search-content":"haivY1iUwlUNzZrMtKts"};